import { onBeforeMount } from 'vue';
import { brand } from 'config';
import useExperiments from '~/stores/useExperimentsStore';
import { usePageData } from '~/composables/usePageData';

export default function onHeader() {
  const { deviceType } = usePageData();
  const { experimentFlags } = useExperiments();

  const isBcom = brand === 'bcom';
  const isPhone = deviceType === 'PHONE';
  const headerHiddenMcomMobileEligible = experimentFlags.isPDPEnhancementKEnabled && isPhone;
  const hiddenClass = isBcom ? 'bcom-hidden' : 'mcom-mobile-hidden-header';

  if (!isPhone && isBcom) return;
  if (!headerHiddenMcomMobileEligible && !isBcom) return;

  const handleScroll = () => {
    const header = document.querySelector('#header');
    if (header === null) return false;
    header?.classList.remove(hiddenClass);
    window.scrollTo(0, header.offsetHeight + window.scrollY);
    return true;
  };

  onBeforeMount(() => {
    const scrollHandler = () => {
      if (handleScroll()) {
        window.removeEventListener('wheel', scrollHandler);
        window.removeEventListener('touchstart', scrollHandler);
      }
    };

    window.addEventListener('wheel', scrollHandler, { passive: true });
    window.addEventListener('touchstart', scrollHandler, { passive: true });
  });
}
